const storageKey = 'experience.register.aff';

const storage = (): Storage | undefined => {
  if (typeof sessionStorage === 'undefined') {
    return undefined;
  }

  return sessionStorage;
};

/** Keep the invite code across /register → /register/password. Empty clears it. */
export const rememberAff = (aff?: string) => {
  const store = storage();

  if (!store) {
    return;
  }

  if (aff) {
    store.setItem(storageKey, aff);
    return;
  }

  store.removeItem(storageKey);
};

/** Current invite code for this tab, or undefined when missing or blank. */
export const peekAff = (): string | undefined => {
  const value = storage()?.getItem(storageKey);

  if (!value) {
    return undefined;
  }

  return value;
};
